module.exports = __webpack_public_path__ + "static/media/homeIcon.389ffbf2.svg";